const tabMenuItems = $(".tabTitle");

$(tabMenuItems).each((i, item) => {

	let itemContent = item.dataset.id,
	    color = $(item).css("border-bottom-color"), 
	    colorLight = color.replace('rgb', 'rgba').replace(')', ',.45)'), 
	    colorZero = color.replace('rgb', 'rgba').replace(')', ',.0)');

	$('#' + itemContent).addClass("tab-content");

	if (i == 0) {
	$(item).css("background-color", colorLight);
	} else {
	$(item).css("background-color", colorZero);
	$("#" + itemContent).css("display", "none");
	}


	$(item).on("click", function(e) {
	e.preventDefault();
	let selectedContent = item.dataset.id;
	$(".tabTitle").css("background-color", colorZero);
	$(item).css("background-color", colorLight);
	$(".tab-content").css("display", "none");
	$('#' + selectedContent).css("display", "block");
});



});
